import { ErrorMessage } from '@hookform/error-message'
import { useFormContext } from 'react-hook-form'
import { useRef, useEffect, useState, useContext } from 'react'
import { useTranslation } from 'next-i18next'
import PropTypes from 'prop-types'
import { UserContext } from '../../context/UserContext'
// Internal components
import FormError from '../FormError/FormError'

const emptyClass = ' not-empty'
const revealClass = ' is-revealed'
const activeClass = ' is-active'

const requiredHint = ' *'

const FormItemTextarea = (props) => {
  const { item, onFormItemLoad, groupedState, revealState, shouldValidateState } = props

  const { register, watch, errors, formState } = useFormContext()
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )
  const requiredErrorMessage = t('FORMITEM__ERROR_REQUIRED')

  const [isRequired, setIsRequired] = useState({ required: false })
  const [isGrouped, setIsGrouped] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)

  const itemRef = useRef()
  const itemValue = watch(item.name)
  const itemProps = item

  useEffect(() => {
    if (!item.revealed && item.required) setIsRequired({ required: requiredErrorMessage })
  }, [])

  useEffect(() => {
    if (isLoaded === false && itemValue) {
      onFormItemLoad({ itemProps, itemRef, itemValue })
      setIsLoaded(true)
    }
  }, [itemValue])

  useEffect(() => {
    if (item.revealed && item.required) setIsRequired({ required: revealState ? requiredErrorMessage : false })
  }, [revealState])

  useEffect(() => {
    if (!shouldValidateState) setIsRequired({ required: false })
  }, [shouldValidateState])

  useEffect(() => {
    if (item?.group && groupedState) {
      const itemLabel = item?.group?.label
      const groupedItem = groupedState.filter((str) => {
        return str.label.indexOf(itemLabel) >= 0
      })
      setIsGrouped(groupedItem[0].active)
    }
  }, [groupedState])

  return (
    <div
      ref={itemRef}
      className={`FormItem FormItem--${item.type}${item.modifier ? ` FormItem--${item.modifier}` : ''}${
        itemValue ? emptyClass : ''
      }${revealState ? revealClass : ''}${!isGrouped ? '' : activeClass}`}
      data-reveal-target={item.revealed}
    >
      <textarea
        type="text"
        id={item.name}
        defaultValue={item.value}
        name={item.name}
        placeholder={`${item.transl ? t(item.transl) : item.label}${item.required ? requiredHint : ''}`}
        className={`FormItem-input FormItem-input--${item.type}`}
        {...register(item.name, isRequired)}
      />
      <label className="FormItem-label" htmlFor={item.name}>{`${item.transl ? t(item.transl) : item.label}${
        item.required ? requiredHint : ''
      }`}</label>
      {formState.isSubmitted && <ErrorMessage errors={errors} name={item.name} as={<FormError />} />}
    </div>
  )
}

FormItemTextarea.propTypes = {
  item: PropTypes.object,
  onFormItemLoad: PropTypes.func,
  revealState: PropTypes.any,
  groupedState: PropTypes.any,
  shouldValidateState: PropTypes.bool
}

export default FormItemTextarea
